<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Library">
      <div class="row">
         <div class="col-md-6 form-group">
          Select Topic
          <b-form-select v-model="topic" :options="topicOption"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Name
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Description
          <input class="form-control" type="text" />
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file id="file-small"></b-form-file>
        </div>
        <div class="col-md-6 form-group">
          Document
          <b-form-file id="file-small"></b-form-file>
        </div>
        <div class="col-md-6 form-group">
          Document Access
          <b-form-select v-model="access" :options="accessOption"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Status
          <b-form-select v-model="selected1" :options="options"></b-form-select>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected1: null,
      options: [{ text: "Active" }, { text: "Deactive" }],
      topic: null,
      topicOption: [{ text: "Class worksheet" }, { text: "Study Material" }],
      access: null,
      accessOption: [{ text: "View" }, { text: "Download" }]
    };
  },
};
</script>

